import {IAction, IFormSubmitAction, IPayloadAction} from 'core/store'
import * as actionTypes from './actionTypes'

interface IActionLoginRequestPayload {
  email: string
  password: string
}
export interface IActionLoginRequest extends
  IFormSubmitAction<typeof actionTypes.LOGIN_REQUEST, IActionLoginRequestPayload> {}
export const loginRequest = (payload: IActionLoginRequestPayload, formName: string): IActionLoginRequest => ({
  type: actionTypes.LOGIN_REQUEST,
  payload,
  form: formName,
})

export interface IActionLogoutRequest extends IAction<typeof actionTypes.LOGOUT_REQUEST> {}
export const logoutRequest = (): IActionLogoutRequest => ({
  type: actionTypes.LOGOUT_REQUEST,
})

interface IActionTokenSetPayload {
  token: string
  role: string
  npis?: string[] | undefined
}
interface IActionTokenSet extends
  IPayloadAction<typeof actionTypes.TOKEN_SET, IActionTokenSetPayload> {}
export const tokenSet = (payload: IActionTokenSetPayload): IActionTokenSet => ({
  type: actionTypes.TOKEN_SET,
  payload,
})

export type TAction =
  IActionLoginRequest |
  IActionTokenSet



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/login/actions.ts